

import clsx from "clsx"
import styles from "./auth.module.scss"

type Props = {
    form: string
    setForm: (form: string) => void
    children: React.ReactNode
}
export default function Component({ form, setForm, children }: Props) {

    return (
        <>
            <div className={styles.top}>
                <button
                    onClick={() => setForm("signIn")}
                    className={clsx({ [styles.active]: form == "signIn" })}
                >
                    Είσοδος
                </button>
                <button
                    onClick={() => setForm("signUp")}
                    className={clsx({ [styles.active]: form == "signUp" })}
                >
                    Εγγραφή
                </button>
            </div>

            {children}
        </>
    )
}